// ─── prerender.js ─────────────────────────────────────────────────────────────
// True while the post-build headless prerender (scripts/prerender.mjs) is
// capturing the page — it loads every route with ?prerender=1. Reveal/lazy
// components read this to render their SETTLED, visible state on first paint so
// the dumped HTML crawlers receive is never blank, opacity:0, or missing a
// below-fold section. (navigator.webdriver is often false under plain headless
// Chrome, so the ?prerender=1 query string is the real signal — see the brain's
// "Post-build prerender" pattern.)
// ──────────────────────────────────────────────────────────────────────────────
export const PRERENDER =
  typeof navigator !== 'undefined' &&
  (navigator.webdriver ||
    (typeof window !== 'undefined' &&
      window.location.search.includes('prerender=1')));
